export default prefix => actionName => `${prefix}/${actionName}`;



// WEBPACK FOOTER //
// ./src/universal/utils/actionPrefix.js